import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core'
import { MatDialog } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ThemeService } from '../../_helpers/theming-engine/theme.service';
import { ColumnDef } from '../../shared/data-table/data-table.model';

@Component({
    selector: 'tc-dialog-component',
    templateUrl: 'tc-dialog.component.html',
    styleUrls: ['tc-dialog.component.css'],
    standalone: false
})
export class TcDashboardComponent implements OnInit {
  @Output() onConfirmed: EventEmitter<any> = new EventEmitter<any>();
  rows: any[] = [];
  columns: ColumnDef[] = [];
  summaryData: any = {
    absences : 0,
    cancellations :0,
    ilp :0,
    sessions : 0,
    pr : 0
  };
  constructor(
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public themeService: ThemeService
  ) { }
  loading: boolean = false;
  ngOnInit() {
    this.buildColumns();
    this.processData();
  }

  private buildColumns(): void {
    this.columns = [
      { field: 'createdDate', header: 'Date', type: 'date', width: '12%' },
      { field: 'tutorFullName', header: 'Tutor', width: '15%' },
      { field: 'studentName', header: 'Learner', width: '15%' },
      { field: 'clientName', header: 'Client', width: '15%' },
      { field: 'description', header: 'Task', type: 'template', templateName: 'task' }
    ];
  }

  private processData() {
    let tmpResult = [];
    let a=0, c=0, i=0, il=0, s=0, p=0;
    this.data.data.userActions.forEach(x => x.forEach(y => {
      let userData = this.data.data.user.find(u => u.placementID === y.placementId);
      if (userData != null) {
        y.studentName = userData.studentName;
        y.tutorName = userData.tutorName;
        y.clientName = userData.clientName;
      }
      if (y.actionType.statusId === 160) {
        a += 1;
      }
      else if (y.actionType.statusId === 170) {
        c += 1;
      }
      else if (y.actionType.statusId === 20) {
        il += 1;
      }
      else if (y.actionType.statusId === 320) {
        s += 1;
      }
      else if (y.actionType.statusId === 220) {
        p += 1;
      }
      tmpResult.push(y);
    }))

    let finalResult = [];
    this.sortData(finalResult, tmpResult, 160);
    this.sortData(finalResult, tmpResult, 170);
    this.sortData(finalResult, tmpResult, 20);
    this.sortData(finalResult, tmpResult, 320);
    this.sortData(finalResult, tmpResult, 220);

    this.summaryData.absences = a;
    this.summaryData.cancellations = c;
    this.summaryData.ilp = il;
    this.summaryData.sessions = s;
    this.summaryData.pr = p;
    this.summaryData.name = this.data.data.user[0].coordinatorName;

    this.rows = finalResult;
  }

  sortData(finalResult, tmpResult, statusId) {
    let data = tmpResult.filter(x => x.actionType.statusId === statusId);
    if (data.length > 0) {
      data.forEach(y => {
        finalResult.push(y);
      })
    }
  }
}
